import * as api from 'api/fundraiserAccounts'

export const CREATE_FUNDRAISER_ACCOUNT = 'CREATE_FUNDRAISER_ACCOUNT'

export const createFundraiserAccount = (userId, stripeAuthorizationCode) => ({
  type: CREATE_FUNDRAISER_ACCOUNT,
  payload: api.createFundraiserAccount(userId, stripeAuthorizationCode)
})
